<template>
	<div class="">
		<div class="w-full bg-white h-[74px]">
			<examHeader :title="title"></examHeader>
			<div class="2xl:w-[1200px] xl:w-[1200px] lg:w-[1000px] mx-auto flex justify-between">
				<div
					class="lg:w-[700px] 2xl:w-[900px] xl:w-[900px]   h-[78vh]  mr-[10px] flex flex-col overflow-hidden">
					<div :style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}"
						class="w-full max-h-[100%]  min-h-[50%] overflow-y-auto bg-repeat  shadow-01 rounded-[6px] mb-[10px] bg-white py-[30px] px-[16px] box-border">
						<div class="mb-[42px]" v-if="current_question_type=='case'">

							<div
								class="answerSheetTitle bB-01  p-[16px] box-border relative text-[16px] text-[#1B2128] font-bold">
								【{{langInfo['Case description']}}】
							</div>
							<div class="pt-[16px] px-[13px] mb-[20px] box-border relative overflow-y-auto"
								style="line-height: 1.6;">
								<label v-html="caseTopicInfo.content"></label>
							</div>

							<div class="flex  mb-[20px]">
								<el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?langInfo.cancel_collect:langInfo.click_collect" placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip>
								<img @click="questionClick()"
									:src="currentTopicInfo.is_user_question==1?questionActive:questionImg"
									class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />

								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
									{{currentTopic + 1 }}.<span v-html="currentTopicInfo.content"
										class="whitespace-pre-wrap"></span>
								</div>
							</div>
							<!-- question_type=题目类型:1=单选,3=判断,5=简答 -->
							<div class="pl-[68px] box-border text-[#101010]" v-if="currentTopicInfo.question_type==1">
								<div @click="selectCaseClick(item,index)" v-for="(item,index) in caseOption"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="item.isSelect?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{item.key}}.</label><label
										class="cursor-pointer" v-html="item.value"></label>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==3">
								<!-- 判断题传 1对0错 -->
								<div @click="selectJudgmentClick('1')"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentTopicInfo.isJudgmentSelect=='1'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['right']}}</label>
								</div>
								<div @click="selectJudgmentClick('0')"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentTopicInfo.isJudgmentSelect=='0'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['wrong']}}</label>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==5">
								<textarea maxlength="200" class="w-[100%] h-[160px]"
									v-model="currentTopicInfo.shortContent"></textarea>

								<div class="flex justify-end">
									<div @click="saveShortTopic()"
										class="min-w-[100px] px-[10px] box-border bg-[#2979FF] h-[28px] leading-[28px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
										{{langInfo['save_btn']}}
									</div>
								</div>
							</div>

						</div>
						<div class="mb-[42px]" v-else-if="current_question_type=='single'">
							<div class="flex  mb-[20px]">
								<el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?langInfo.cancel_collect:langInfo.click_collect" placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip>
								<img @click="questionClick()"
									:src="currentTopicInfo.is_user_question==1?questionActive:questionImg"
									class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />

								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
									{{currentTopic + 1 }}.<span v-html="currentTopicInfo.content"
										class="whitespace-pre-wrap"></span>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]">
								<div @click="selectClick(item,index)" v-for="(item,index) in optionsList"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="item.isSelect?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{item.key}}.</label><label
										class="cursor-pointer" v-html="item.value"></label>
								</div>
							</div>
						</div>

					</div>
					<div class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()" :class="currentNumber==1?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()"
							:class="currentNumber==Number(question_paper_question_count)?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>
				</div>
				<div class="flex-1">
					<div
						class="h-[46vh] mb-[10px]  overflow-y-auto pb-[24px] box-border flex flex-col shadow-01 rounded-[6px]  bg-white">

						<div
							class="answerSheetTitle bB-01 mb-[10px]  p-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
							{{langInfo.study_paper_card}}
						</div>
						<div class="">
							<div class="" v-for="(item,index) in topicList" :key="index">
								<div
									class="px-[20px] mb-[10px] box-border relative text-[16px] text-[#1B2128] font-bold">
									Part {{index+1}} {{item.name}}
								</div>

								<div v-if="item.question_type=='single'" class="flex flex-wrap overflow-y-auto    px-[13px] box-border ">
									<div @click="selectTopic(item,index,ite,inde)"
										:class="[ ite.userrecord && ite.userrecord.user_answer?'bg-[#ff9000] text-white':'', currentTopic==inde&&partIndex==index?'bg-[#A6A6A6] text-white':'']"
										class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
										v-for="(ite,inde) in item.data" :key="inde">
										<img v-if="ite.question.is_user_question==1&&ite.question.is_user_collection==1"
											src="@/static/image/icon55.png"
											class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt="" srcset="" />
										<img v-else-if="ite.question.is_user_question==1"
											src="@/static/image/icon55.png"
											class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt=""
											srcset="" />

										<img v-if="ite.question.is_user_collection==1" :src="collectActive"
											class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
											alt="" srcset="" />
										<label class="cursor-pointer"> {{inde + 1 }}</label>
									</div>
								</div>
								<div class="" v-else-if="item.question_type=='case'">

									<div class="" v-for="(ite,ind) in item.data" :key="ind">
										<div
											class="px-[20px] mb-[10px] box-border relative text-[16px] text-[#1B2128] font-bold">
											{{langInfo['case']}} {{ind+1}}
										</div>
										<div class="flex flex-wrap overflow-y-auto   px-[13px] box-border ">

											<div @click="selectCaseTopic(item,index,ite,ind,iteClass,indeClass)"
												:class="[ iteClass.userrecord && (iteClass.userrecord.user_answer || iteClass.userrecord.user_answer==='0')?'bg-[#ff9000] text-white':'', partIndex==index &&caseIndex==ind&&currentTopic==indeClass?'bg-[#A6A6A6] text-white':'']"
												class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
												v-for="(iteClass,indeClass) in ite.data" :key="indeClass">
												<img v-if="iteClass.question.is_user_question==1&&iteClass.question.is_user_collection==1"
													src="@/static/image/icon55.png"
													class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt=""
													srcset="" />
												<img v-else-if="iteClass.question.is_user_question==1"
													src="@/static/image/icon55.png"
													class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt=""
													srcset="" />

												<img v-if="iteClass.question.is_user_collection==1" :src="collectActive"
													class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
													alt="" srcset="" />
												<label class="cursor-pointer">{{indeClass+1}}</label>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>

						<!-- <div class="  flex items-center justify-center mt-[14px]">
							<div @click="prePartBtn()" :class="partIndex==0?'bg-[#8FC3FF]':'bg-[#2979FF] '"
								class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
								上一部分
							</div>
							<div @click="nextPart()" :class="partIndex+1==partList.length?'bg-[#8FC3FF]':'bg-[#2979FF]'"
								class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-white text-[14px] rounded-[6px] cursor-pointer">
								下一部分
							</div>
						</div> -->
					</div>
					<div
						class=" mb-[10px] h-[16vh] px-[16px] flex flex-col justify-center  shadow-01 rounded-[6px]  bg-white">
						<div class="text-[#686C73] flex items-center justify-center mb-[6px]">
							<img src="@/static/image/icon39.png" class="w-[20px] h-[20px]  mr-[10px]" alt="" />
							{{langInfo.study_paper_countdown}}
						</div>
						<div class="mb-[10px] text-[20px] font-bold text-[#E58039] text-center">
							{{remainingTime}}
						</div>
						<el-progress class="mb-[28px]" :text-inside="true" :stroke-width="10" :show-text="false"
							:percentage="percentage"></el-progress>
						<div class="flex items-center justify-between">
							<label class="text-[#E58039]">{{langInfo.study_paper_over}} {{finishNum}}
								{{langInfo.study_paper_count}}</label>
							<label
								class="text-[#686C73]">{{langInfo.study_paper_all}}{{question_paper_question_count}}{{langInfo.study_paper_count}}</label>
						</div>
					</div>

					<div class="mb-[10px] shadow-01 rounded-[6px] h-[60px] bg-white flex items-center justify-center">
						<div @click="stopPaper()"
							class="bg-[#D86D21] w-[100px] h-[28px] leading-[28px] mr-[14px] text-center text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_stop}}
						</div>
						<div @click="handPaper()"
							class="bg-[#2979FF] w-[100px] h-[28px] leading-[28px] text-center text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_submit}}
						</div>
					</div>

					<div
						class="shadow-01 rounded-[6px]  bg-white leading-[17px] text-[#FF0000] text-[12px] py-[12px] px-[17px] box-border">
						{{langInfo.study_paper_tip}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import examHeader from '@/components/examHeader.vue'
	export default {
		components: {

			examHeader
		},
		data() {
			return {
				title: '',
				selectImg: require('@/static/image/icon37.png'),
				selectedImg: require('@/static/image/icon38.png'),

				collectActive: require('@/static/image/icon22Active.png'),
				collectImg: require('@/static/image/icon22.png'),

				questionActive: require('@/static/image/icon36Active.png'),
				questionImg: require('@/static/image/icon36.png'),
				// 选项
				optionsList: [],
				finishNum: 0, //完成数量
				// 当前题
				currentTopic: 0,
				currentTopicInfo: {
					id: '',
					content: '',
					question_type: '',
					shortContent: '',
					isJudgmentSelect: '',
				},
				// 题列表
				topicList: [],

				// 倒计时
				remainingTime: '00:00:00',

				currentSecond: 0, //当前已用秒数
				percentage: 0, //进度
				countdownTimer: null,

				id: '',

				questionInfo: {},
				identification: '',
				order_item_id: '',
				examStatus: "", //考试状态:pending=待定,tentative=暂停,in_progress=继续,complete=完成

				langInfo: {},
				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username + '@' + this.$common
					.currentTime() + '@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,
				type: '', //1 自由  2后台
				isFinish: false,

				question_paper_id: '',
				partList: [],
				partIndex: 0,
				part_info: { name: '' },
				caseTopicList: [],
				question_type: '', //6 案例分析题

				caseIndex: 0,

				caseTopicInfo: {
					id: '',
					content: '',
					question_type: '',

					userrecord: null
				},
				caseOption: [],
				currentNumber: 0,
				question_paper_question_count: 0,
				sequence: 1, //1正序  2倒序 

				current_question_type: 'single', //single   case


			}
		},
		mounted() {
			// this.unloadshim()
			window.addEventListener('beforeunload', e => this.handleUnload(e))
			this.id = this.$route.query.id
			this.identification = this.$route.query.identification
			this.order_item_id = this.$route.query.order_item_id
			this.getQuestionInfo()

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}

		},
		beforeDestroy() {
			window.removeEventListener('beforeunload', e => this.handleUnload(e));

			clearInterval(this.countdownTimer); // 停止定时器
			this.countdownTimer = null
			if (this.examStatus != 'complete') {
				this.stopStatus() //修改暂停状态
			}
		},

		destroyed() {
			console.log("销毁")
			clearInterval(this.countdownTimer); // 停止定时器
			this.countdownTimer = null

			console.log("销毁===========");

			localStorage.removeItem('currentTopic')

			if (this.examStatus != 'complete') {
				this.stopStatus() //修改暂停状态
			}
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			unloadshim() {
				window.onbeforeunload = (e) => {
					e = e || window.event;
					console.log("e=====");
					console.log(e);
					// 适配IE8, Firefox 4之前版本
					if (e) e.returnValue = '关闭提示';
					// 适配Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
					return '关闭提示';
				}
			},
			// 注入网页关闭/刷新/前进后退阻止器
			// 执行函数或方法
			handleUnload(e) {

				this.stopStatus() //修改暂停状态
			},

			handleBeforeUnload() {
				event.preventDefault();
				console.log("刷新");
				this.stopStatus() //修改暂停状态
			},
			getCurrentInfo() {


				this.current_question_type = this.topicList[this.partIndex].question_type


				if (this.topicList[this.partIndex].question_type == "single") {

					this.optionsList = []
					this.caseOption = []

					let info = this.topicList[this.partIndex].data[this.currentTopic]
					this.currentTopicInfo = this.topicList[this.partIndex].data[this.currentTopic].question;





					this.optionsList = this.currentTopicInfo.options
					if (info.userrecord) {
						let userrecord = info.userrecord
						this.optionsList.forEach((item, index) => {
							this.$set(item, 'isSelect', false)
							if (userrecord.user_answer == item.key) {
								item.isSelect = true
							} else {
								item.isSelect = false
							}
						})
					} else {
						console.log("无");
						this.optionsList.forEach((item, index) => {
							this.$set(item, 'isSelect', false)
						})
					}

				} else if (this.topicList[this.partIndex].question_type == "case") {
					this.currentTopicInfo = this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].question;

					this.optionsList = []
					this.caseOption = []

					this.caseTopicInfo = this.topicList[this.partIndex].data[this.caseIndex]

					let userrecord = this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord
					if (this.currentTopicInfo.question_type == 1) {
						this.caseOption = this.currentTopicInfo.options

						for (var h = 0; h < this.caseOption.length; h++) {
							let op = this.caseOption[h]
							this.$set(op, 'isSelect', false)
							if (userrecord) {
								if (userrecord.user_answer == op.key) {
									op.isSelect = true
								} else {
									op.isSelect = false
								}
							} else {
								op.isSelect = false
							}
						}
					} else if (this.currentTopicInfo.question_type == 3) {
						if (userrecord) {
							this.currentTopicInfo.isJudgmentSelect = userrecord.user_answer
						} else {
							this.currentTopicInfo.isJudgmentSelect = -1
						}

					} else if (this.currentTopicInfo.question_type == 5) {
						if (userrecord) {
							this.currentTopicInfo.shortContent = userrecord.user_answer
						} else {
							this.currentTopicInfo.shortContent = ''
						}
					}

				}
				
				
				this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)
				

				this.getCurrentNumber()
				this.get_user_log()
			},
			
			decodeHtml(html) {
				if (!html) return ''
				const textarea = document.createElement('textarea')
				textarea.innerHTML = html
			
				return textarea.value
			},
			
			getCurrentNumber() {
				console.log("获取数量=====");

				let num = 0

				let tpIndex = 0
				let isExit = false
				for (let i = 0; i < this.topicList.length; i++) {
					console.log("i===" + i);
					let item = this.topicList[i];
					if (item.question_type == 'single') {
						for (let j = 0; j < item.data.length; j++) {
							let itm = item.data[j];
							if (this.partIndex == i && this.currentTopic == j) {
								isExit = true
								break;
							}
							tpIndex++
						}
					} else if (item.question_type == 'case') {

						for (let j = 0; j < item.data.length; j++) {
							let itm = item.data[j];

							if (isExit == true) {
								break
							}
							for (let d = 0; d < itm.data.length; d++) {
								if (this.partIndex == i && this.caseIndex == j && this.currentTopic == d) {
									isExit = true
									break;
								}
								tpIndex++
							}
						}
					}
				}

				this.currentNumber = tpIndex + 1
			},

			get_user_log() {
				this.$api.user_log({
					action: 'question',
					type: this.type,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},

			getAnsweredNum() {

				let num = 0


				this.topicList.forEach((item, index) => {
					if (item.question_type == 'single') {
						item.data.forEach((itm, ind) => {
							if (itm.userrecord && itm.userrecord.user_answer) {
								num++
							}
						})

					} else if (item.question_type == 'case') {

						item.data.forEach((itm, ind) => {
							itm.data.forEach((it, ind) => {
								if (it.userrecord && it.userrecord.user_answer) {
									num++
								}
							})
						})
					}
				})


				this.finishNum = num
				this.percentage = Number(this.finishNum) / Number(this.question_paper_question_count) * 100
			},
			getQuestionInfo() {

				this.$api.getQuestionPart({
					id: this.id,
					identification: this.identification,
					order_item_id: this.order_item_id,
					question_paper_id: this.question_paper_id
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.title = res.data.title

					this.question_paper_question_count = res.data.question_paper_question_count

					document.title = this.title

					this.partList = res.data.part
					//question_type 题型：single=单选,multiple=多选,judge=判断,essay=简答,case=案例分析

					this.questionInfo = res.data
					this.type = res.data.type


					// is_user_collection=是否收藏0否1是


					res.data.part.forEach((item, index) => {
						if (item.question_type == 'single') {
							item.data.forEach((itm, indx) => {
								itm.question.options.forEach((it, ind) => {
									this.$set(it, 'isSelect', false)
								})

							})
						} else if (item.question_type == 'case') {

							item.data.forEach((itm, indx) => {
								itm.data.forEach((it, ind) => {

									if (it.question.question_type == 1) {
										it.question.options.forEach((it1, ind1) => {
											this.$set(it1, 'isSelect', false)
										})
									} else if (it.question.question_type == 5) {
										this.$set(it.question, 'shortContent', '')
									} else if (it.question.question_type == 3) {
										this.$set(it.question, 'isJudgmentSelect', -1)
									}
								})
							})

						}
					})


					let tpIndex = 0
					let isExit = false
					for (let i = 0; i < res.data.part.length; i++) {
						let item = res.data.part[i];
						if (item.question_type == 'single') {
							for (let j = 0; j < item.data.length; j++) {
								let itm = item.data[j];
								if (tpIndex == res.data.key_) {
									this.partIndex = i
									this.currentTopic = j;

									isExit = true
									break;
								}
								tpIndex++
							}


						} else if (item.question_type == 'case') {

							for (let j = 0; j < item.data.length; j++) {
								let itm = item.data[j];

								if (isExit == true) {
									break
								}
								for (let d = 0; d < itm.data.length; d++) {
									if (tpIndex == res.data.key_) {
										this.partIndex = i
										this.caseIndex = j
										this.currentTopic = d;
										isExit = true
										break;
									}
									tpIndex++
								}

							}

						}

					}

					if (this.questionInfo.question_exam) {
						if (this.questionInfo.question_exam.status == "tentative") {
							this.stopShowPopup() //显示暂停弹框
						}
					}

					if (res.data.time >= 0) {
						this.countTime(res.data.time)
					}
					this.topicList = res.data.part



					this.getCurrentInfo()

					this.getAnsweredNum()
				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			getNextQuestionInfo() {
				this.$api.getQuestionPart({
					id: this.id,
					identification: this.identification,

					order_item_id: this.order_item_id,
					question_paper_id: this.question_paper_id

				}).then((res) => {
					console.log(res);

					this.question_paper_question_count = res.data.question_paper_question_count
					this.partList = res.data.part
					//question_type 题型：single=单选,multiple=多选,judge=判断,essay=简答,case=案例分析

					// is_user_collection=是否收藏0否1是

					res.data.part.forEach((item, index) => {
						if (item.question_type == 'single') {
							item.data.forEach((itm, indx) => {
								itm.question.options.forEach((it, ind) => {
									this.$set(it, 'isSelect', false)
								})

							})
						} else if (item.question_type == 'case') {

							item.data.forEach((itm, indx) => {
								itm.data.forEach((it, ind) => {

									if (it.question.question_type == 1) {
										it.question.options.forEach((it1, ind1) => {
											this.$set(it1, 'isSelect', false)
										})
									} else if (it.question.question_type == 5) {
										this.$set(it.question, 'shortContent', '')
									} else if (it.question.question_type == 3) {
										this.$set(it.question, 'isJudgmentSelect', -1)
									}
								})
							})

						}
					})


					let tpIndex = 0
					let isExit = false
					for (let i = 0; i < res.data.part.length; i++) {
						let item = res.data.part[i];
						if (item.question_type == 'single') {
							for (let j = 0; j < item.data.length; j++) {
								let itm = item.data[j];
								if (tpIndex == res.data.key_) {
									this.partIndex = i
									this.currentTopic = j;

									isExit = true
									break;
								}
								tpIndex++
							}


						} else if (item.question_type == 'case') {

							for (let j = 0; j < item.data.length; j++) {
								let itm = item.data[j];

								if (isExit == true) {
									break
								}
								for (let d = 0; d < itm.data.length; d++) {
									if (tpIndex == res.data.key_) {
										this.partIndex = i
										this.caseIndex = j
										this.currentTopic = d;
										isExit = true
										break;
									}
									tpIndex++
								}

							}

						}

					}

					if (this.questionInfo.question_exam) {
						if (this.questionInfo.question_exam.status == "tentative") {
							this.stopShowPopup() //显示暂停弹框
						}
					}

					if (res.data.time >= 0) {
						this.countTime(res.data.time)
					}
					this.topicList = res.data.part

					this.getCurrentInfo()

					this.getAnsweredNum()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			// 判断题
			selectJudgmentClick(answer) {



				this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].isJudgmentSelect = answer

				if (this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord) {
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord.user_answer =answer
				} else {

					this.$set(this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic],'userrecord', {})
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord.user_answer =
						answer
				}
				this.currentTopicInfo.isJudgmentSelect = answer

				this.getAnsweredNum()


				this.$api.recordQuestion({
					question_paper_id: this.id,
					course_question_id: this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].id,
					user_answer: answer,
					mode: 3,
					identification: this.questionInfo.identification
				}).then((res) => {
					console.log(res);

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})


			},
			// 保存简答题
			saveShortTopic() {

				if (this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord) {
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord.user_answer =this.currentTopicInfo.shortContent
				} else {
					this.$set(this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic],'userrecord', {})
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord.user_answer =this.currentTopicInfo.shortContent
				}

				this.getAnsweredNum()

				this.$api.recordQuestion({
					question_paper_id: this.id,
					course_question_id: this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].id,
					user_answer: this.currentTopicInfo.shortContent,
					mode: 3,
					identification: this.questionInfo.identification
				}).then((res) => {
					console.log(res);

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})


			},
			selectCaseClick(item, index) {

				//question_type=题目类型:1=单选,3=判断,5=简答

				console.log(item);
				this.caseOption.forEach((itm, ind) => {
					if (index == ind) {
						itm.isSelect = !itm.isSelect
						item.isSelect = itm.isSelect
					} else {
						itm.isSelect = false
					}
				})

				if (this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord) {
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord.user_answer =item.isSelect ? item.key : ''
				} else {
					this.$set(this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic],
						'userrecord', {})
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].userrecord.user_answer =item.isSelect ? item.key : ''
				}

				this.getAnsweredNum()

				// question_paper_id=试卷id
				// course_question_id=题目id
				// user_answer=用户答案
				// mode=模式 模式:1=练习,2=错题,3=模拟考试
				// identification=试卷标识
				this.$api.recordQuestion({
					question_paper_id: this.id,
					course_question_id: this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].id,
					user_answer: item.isSelect ? item.key : '',
					mode: 3,
					identification: this.questionInfo.identification
				}).then((res) => {
					console.log(res);

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})


			},
			selectClick(item, index) {
				console.log(item);
				this.optionsList.forEach((itm, ind) => {
					if (index == ind) {
						itm.isSelect = !itm.isSelect
					} else {
						itm.isSelect = false
					}
				})

				if (this.topicList[this.partIndex].data[this.currentTopic].userrecord) {
					this.topicList[this.partIndex].data[this.currentTopic].userrecord.user_answer = item.isSelect ? item.key : ''
				} else {
					this.topicList[this.partIndex].data[this.currentTopic].userrecord = {}
					this.topicList[this.partIndex].data[this.currentTopic].userrecord.user_answer = item.isSelect ? item.key : ''
				}

				this.getAnsweredNum()

				// question_paper_id=试卷id
				// course_question_id=题目id
				// user_answer=用户答案
				// mode=模式 模式:1=练习,2=错题,3=模拟考试
				// identification=试卷标识
				this.$api.recordQuestion({
					question_paper_id: this.id,
					course_question_id: this.topicList[this.partIndex].data[this.currentTopic].id,
					user_answer: item.isSelect ? item.key : '',
					mode: 3,
					identification: this.questionInfo.identification
				}).then((res) => {
					console.log(res);

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			// 上一页
			preTopic() {


				if (this.currentNumber == 1) {
					return
				}


				if (this.topicList[this.partIndex].question_type == "case") {

					if (this.currentTopic == 0 && this.caseIndex == 0 && this.partIndex > 0) {
						this.sequence = 2;
						this.partIndex--
						this.getPreInfo()
						return
					} else if (this.currentTopic == 0 && this.caseIndex > 0 && this.partIndex > 0) {
						this.sequence = 2
						this.caseIndex--
						this.getPreInfo()
						return
					}
					this.currentTopic--
					this.sequence = 2
					this.getCurrentInfo()


				} else if (this.topicList[this.partIndex].question_type == "single") {

					if (this.currentTopic == 0 && this.partIndex > 0) {
						this.partIndex--
						this.sequence = 2
						this.getPreInfo()
						return
					}

					this.currentTopic--
					this.sequence = 2
					this.getCurrentInfo()
				}

			},


			getPreInfo() {
			

				if (this.topicList[this.partIndex].question_type == "case") {
					
					this.currentTopic=this.topicList[this.partIndex].data[this.caseIndex].data.length - 1
				  this.getCurrentInfo()
				
				} else if (this.topicList[this.partIndex].question_type == "single") {
					console.log("this.topicList[this.partIndex]==");
					console.log(this.topicList[this.partIndex].data);
					this.currentTopic =  this.topicList[this.partIndex].data.length -1
					
					this.getCurrentInfo()

				}

			},

			nextTopic() {

				if (this.currentNumber == this.question_paper_question_count) {
					return
				}

				if (this.topicList[this.partIndex].question_type == "case") {

					if (this.currentTopic == this.topicList[this.partIndex].data[this.caseIndex].data.length - 1) {
						if (this.caseIndex == this.topicList[this.partIndex].data.length - 1) {
							if (this.partIndex == this.topicList.length - 1) {
								return
							}

							this.currentTopic = 0
							this.caseIndex++
							this.sequence = 1
							this.getCurrentInfo()
							return

						}

						this.currentTopic = 0
						this.caseIndex++
						this.sequence = 1
						this.getCurrentInfo()

						return
					}

					this.currentTopic++
					this.sequence = 1
					this.getCurrentInfo()

				} else if (this.topicList[this.partIndex].question_type == "single") {


					if (Number(this.currentTopic) + 1 == this.topicList[this.partIndex].data.length) {
						if (this.partIndex == this.topicList.length - 1) {
							return
						}
						this.currentTopic = 0
						this.caseIndex = 0
						this.partIndex++
						this.sequence = 1
						this.getCurrentInfo()
						return
					}


					this.currentTopic++
					this.sequence = 1
					this.getCurrentInfo()

				}
			},
			prePartBtn() {
				this.caseIndex = 0
				this.sequence = 1
				this.prePartInfo()
			},

			// 上一部分
			prePartInfo() {
				if (this.partIndex == 0) {
					return
				}
				this.partIndex--
				this.question_paper_id = this.partList[this.partIndex].id;
				this.getNextQuestionInfo()

			},
			nextPart() {
				if (this.partIndex + 1 == this.partList.length) {
					return
				}


				this.caseIndex = 0
				this.sequence = 1;
				this.partIndex++
				this.question_paper_id = this.partList[this.partIndex].id;
				this.getNextQuestionInfo()
			},


			selectTopic(item, index, ite, inde) {

				this.currentTopic = inde
				this.partIndex = index
				this.getCurrentInfo()
			},

			selectCaseTopic(item, index, ite, ind, iteClass, indeClass) {
				this.partIndex = index;
				this.caseIndex = ind;
				this.currentTopic = indeClass


				this.getCurrentInfo()
			},

			countTime(duration) {
				let timer = duration,
					hour, minutes, seconds;
				hour = parseInt(timer / 60 / 60, 10);
				minutes = parseInt(timer / 60 % 60, 10);
				seconds = parseInt(timer % 60, 10);

				hour = hour < 10 ? "0" + hour : hour;
				minutes = minutes < 10 ? "0" + minutes : minutes;
				seconds = seconds < 10 ? "0" + seconds : seconds;
				this.remainingTime = `${hour}:${minutes}:${seconds}`;



				if (this.questionInfo.question_exam.status == "pending" || this.questionInfo.question_exam.status ==
					"in_progress") {
					this.startCountdown(duration);
				}

			},
			// 更新倒计时的函数

			startCountdown(duration) {
				let timer = duration,
					hour, minutes, seconds;
				const interval = 1000; // 1秒更新一次

				const timerFunction = () => {
					if (timer-- <= 0) {
						clearInterval(this.countdownTimer); // 停止定时器
						this.countdownTimer = null
						console.log("时间到了");
						this.examEnd()
						return
					}
					hour = parseInt(timer / 60 / 60, 10);
					minutes = parseInt(timer / 60 % 60, 10);
					seconds = parseInt(timer % 60, 10);

					hour = hour < 10 ? "0" + hour : hour;
					minutes = minutes < 10 ? "0" + minutes : minutes;
					seconds = seconds < 10 ? "0" + seconds : seconds;
					this.remainingTime = `${hour}:${minutes}:${seconds}`
					this.currentSecond++


				};
				timerFunction()
				this.countdownTimer = setInterval(timerFunction, interval);
			},
			examEnd() {
				console.log("考试结束");
			},
			// 暂停
			stopPaper() {
				console.log("暂停");
				clearInterval(this.countdownTimer); // 停止定时器
				this.countdownTimer = null
				// pause=暂停,resume=继续,complete=完成
				this.$api.updateExamStatus({
					action: 'pause',
					identification: this.questionInfo.identification
				}).then((res) => {
					this.stopShowPopup() //显示暂停弹框
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			stopStatus() {
				// pause=暂停,resume=继续,complete=完成
				this.$api.updateExamStatus({
					action: 'pause',
					identification: this.questionInfo.identification
				}).then((res) => {
					console.log(res);
				}).catch((error) => {

				})
			},

			stopShowPopup() {
				var that = this
				this.$alert(
					this.langInfo.study_paper_tip,
					this.langInfo.study_paper_stop_tip, {
						confirmButtonText: this.langInfo.study_exam_continue,
						callback: action => {
							console.log(action);
							if (action == 'confirm') {
								// pause=暂停,resume=继续,complete=完成
								this.$api.updateExamStatus({
									action: 'resume',
									identification: this.questionInfo.identification
								}).then((res) => {
									console.log(res);
									that.getExamTime() //获取考试时间

									this.$message({
										message: res.msg,
										type: 'success'
									})
								}).catch((error) => {
									this.$message({
										message: error.msg,
										type: 'warning'
									})
								})
							}
						}
					});
			},

			getExamTime() {
				this.$api.getQuestionPart({
					id: this.id,
					identification: this.identification
				}).then((res) => {
					console.log(res);
					this.questionInfo = res.data
					if (res.data.time >= 0) {
						this.countTime(res.data.time)
					}
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			// 交卷
			handPaper() {
				console.log("交卷");
				clearInterval(this.countdownTimer); // 停止定时器
				this.countdownTimer = null

				this.$confirm(this.langInfo.phone_finish_paper_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'info'
				}).then(() => {
					this.examStatus = 'complete'
					this.completePaper()
				}).catch(() => {

				});
			},
			completePaper() {
				this.$api.updateExamStatus({
					action: 'complete',
					identification: this.questionInfo.identification
				}).then((res) => {
					this.$message({
						message: res.msg,
						type: 'success'
					})
					setTimeout(() => {
						this.$router.push({
							path: '/exam/examOver',
							query: {
								id: res.data.id,
								identification: this.identification,
								order_item_id: this.order_item_id
							}
						})
					}, 800)
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			// 收藏
			collectClick() {
				console.log(12121);
				let course_question_id = this.currentTopicInfo.id
				
				
				if (this.currentTopicInfo.is_user_collection == 1) {
					this.currentTopicInfo.is_user_collection = 0
				} else {
					this.currentTopicInfo.is_user_collection = 1
				}
				
				if (this.topicList[this.partIndex].question_type == "case") {
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].question.is_user_collection = this.currentTopicInfo.is_user_collection
				} else if (this.topicList[this.partIndex].question_type == "single")  {
					
					this.topicList[this.partIndex].data[this.currentTopic].question.is_user_collection = this.currentTopicInfo.is_user_collection
				
				}
				

				// type=类型:1=课程,2=咨询,3=资源,4=题目
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 4,
					course_question_id: course_question_id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 疑问标记
			questionClick() {
				
				let course_question_id = this.currentTopicInfo.id
				
				if (this.currentTopicInfo.is_user_question == 1) {
					this.currentTopicInfo.is_user_question = 0
				} else {
					this.currentTopicInfo.is_user_question = 1
				}
				
				if (this.topicList[this.partIndex].question_type == "case") {
					this.topicList[this.partIndex].data[this.caseIndex].data[this.currentTopic].question.is_user_question = this.currentTopicInfo.is_user_question
				} else if (this.topicList[this.partIndex].question_type == "single")  {
					
					this.topicList[this.partIndex].data[this.currentTopic].question.is_user_question = this.currentTopicInfo.is_user_question
				}


				// type=类型:1=课程,2=咨询,3=资源,4=题目  5 疑问
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 5,
					course_question_id: course_question_id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功、疑问
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			}

		}
	}
</script>

<style scoped>
	
	
	/deep/p img {
		width: 100% !important;
	}
	
	/* ::-webkit-scrollbar {
		display: none;
	} */

	.answerSheetTitle::after {
		content: '';
		position: absolute;
		width: 4px;
		height: 21px;
		background-color: rgba(103, 194, 58, 1);
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.topicItem:nth-child(5n) {
		margin-right: 0;

	}

	.topicItem {
		width: 18%;
		height: 30px;
		line-height: 30px;
		margin-right: 2.5%;
		border: 1px solid rgba(187, 187, 187, 1);
	}
</style>